"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.map");

var _md = _interopRequireDefault(require("md5"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _propValidators = require("../utils/propValidators");

var _CalendarRow = _interopRequireDefault(require("./CalendarRow"));

var _getDates = _interopRequireDefault(require("./utils/getDates"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CalendarContent = function CalendarContent(_ref) {
  var due = _ref.due,
      late = _ref.late,
      mode = _ref.mode,
      onSelect = _ref.onSelect,
      unavailable = _ref.unavailable,
      value = _ref.value,
      viewDate = _ref.viewDate;
  var dates = (0, _getDates["default"])(viewDate, mode);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grv-calendar__content"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("table", {
    className: "grv-calendar__table"
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    className: "grv-calendar__table-header"
  }, mode === 'month' ? /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    "aria-label": "Sunday"
  }, "S"), /*#__PURE__*/_react["default"].createElement("th", {
    "aria-label": "Monday"
  }, "M"), /*#__PURE__*/_react["default"].createElement("th", {
    "aria-label": "Tuesday"
  }, "T"), /*#__PURE__*/_react["default"].createElement("th", {
    "aria-label": "Wednesday"
  }, "W"), /*#__PURE__*/_react["default"].createElement("th", {
    "aria-label": "Thursday"
  }, "T"), /*#__PURE__*/_react["default"].createElement("th", {
    "aria-label": "Friday"
  }, "F"), /*#__PURE__*/_react["default"].createElement("th", {
    "aria-label": "Saturday"
  }, "S")) : null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    "aria-hidden": "true",
    className: "grv-calendar__table-header-divider",
    colSpan: mode === 'month' ? 7 : 4
  }))), /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "grv-calendar__body"
  }, dates.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement(_CalendarRow["default"], {
      dates: row,
      due: due,
      key: (0, _md["default"])(row),
      late: late,
      mode: mode,
      onSelect: onSelect,
      unavailable: unavailable,
      value: value
    });
  })))));
};

var propTypes = {
  due: _propValidators.dateSetType,
  late: _propValidators.dateSetType,
  mode: _propTypes["default"].oneOf(['month', 'year']).isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  unavailable: _propValidators.dateSetType,
  value: _propTypes["default"].oneOfType([_propValidators.dateType, _propTypes["default"].arrayOf(_propValidators.dateType)]),
  viewDate: _propValidators.dateType.isRequired
};
CalendarContent.propTypes = propTypes;
var _default = CalendarContent;
exports["default"] = _default;